module.exports = __webpack_public_path__ + "static/media/GOL_opt.4045f985.png";